import { Component, OnInit, ViewChild, ElementRef, Input } from "@angular/core";

export interface NewsAnimatorModel {
    message: string;
    fontColorClass?: string;
}

@Component({
    selector: "app-news-animator",
    styleUrls: ["./news-animator.component.scss"],
    templateUrl: "./news-animator.component.html"
})
export class NewsAnimatorComponent implements OnInit {
    @ViewChild("headerNewsLabel", { static: false }) headerNewsLabel: ElementRef;
    @Input() messages: Array<NewsAnimatorModel> = [];
    centerNotificationLabel = "";
    animationSpeen = 15;

    constructor() { }

    ngOnInit(): void {
        this.centerNotificationLabel = "";

        if (this.messages && this.messages.length > 0) {
            this.messages.forEach(z => {
                const separator = this.centerNotificationLabel.length === 0 ? "" : "<span class=\"margin-left-30\"></span>|<span class=\"margin-left-30\"></span>";
                this.centerNotificationLabel += `<span class="${z.fontColorClass}">${separator}${z.message}</span>`;
            });

            setTimeout(() => {
                this.headerNewsLabel.nativeElement.style["animation-duration"] = (this.messages.length * this.animationSpeen) + "s";
            }, 10);
        }
    }

    pauseNewsAnimation() {
        this.headerNewsLabel.nativeElement.style["animation-play-state"] = "paused";
    }

    continueNewsAnimation() {
        this.headerNewsLabel.nativeElement.style["animation-play-state"] = "running";
    }
}